var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as d3 from 'd3';
import React from 'react';
import * as topojson from 'topojson-client';
import timezoneTopoJson from './assets/timezones.json';
import { findTimeZone } from './Util';
/**
 * Read world map polygon data.
 * @returns array of polygon data
 */
var createTimeZonePolygonFeatures = function () {
    // Read world map for timezones.
    // See https://github.com/evansiroky/timezone-boundary-builder
    //     https://github.com/topojson/topojson
    //
    // Somehow TS type definition does not match with the actual data, and I need to resort to
    // forceful casting.
    var tzData = timezoneTopoJson;
    var tzDataFeature = topojson.feature(tzData, tzData.objects.timezones);
    var features = tzDataFeature.features;
    return features;
};
var WorldMap = function (props) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var handleClick = function (e) {
        // We have a few "unresolved" areas on map. We ignore clicking on those areas.
        var timezone = findTimeZone(e.target.id);
        if (timezone) {
            props.onChange(timezone.name);
        }
    };
    var pathGenerator = d3.geoPath();
    var timeZonePolygonFeatures = React.useMemo(createTimeZonePolygonFeatures, []);
    var selectedTimeZone = findTimeZone(props.timeZoneName);
    var tzPaths = timeZonePolygonFeatures.map(function (d) {
        var _a;
        var id = "".concat((_a = d.properties) === null || _a === void 0 ? void 0 : _a.id);
        // Time zone corresponding to the polygon.
        var timeZone = findTimeZone(id);
        var opacity;
        var stroke;
        var fill;
        if (selectedTimeZone && selectedTimeZone === timeZone) {
            opacity = 1.0;
            stroke = 'darkgrey';
            fill = 'darkgrey';
        }
        else if (selectedTimeZone && timeZone &&
            selectedTimeZone.rawOffsetInMinutes === timeZone.rawOffsetInMinutes) {
            opacity = 0.7;
            stroke = 'grey';
            fill = 'lightgrey';
        }
        else {
            opacity = 0.4;
            stroke = 'lightgrey';
            fill = 'lightgrey';
        }
        var generatedPath = pathGenerator(d) || undefined;
        var title = timeZone ? "".concat(timeZone.countryName, " / ").concat(timeZone.mainCities[0]) : '';
        return (_jsx("path", __assign({ id: id, "data-testid": id, d: generatedPath, opacity: opacity, fill: fill, strokeWidth: 0.5, stroke: stroke, onClick: handleClick }, { children: _jsx("title", { children: title }) }), id));
    });
    return (_jsx("svg", __assign({ viewBox: "0 0 800 320", width: 700 }, { children: _jsx("g", __assign({ style: { cursor: 'pointer' }, transform: "matrix(2 0 0 -2 400 200)" }, { children: tzPaths })) })));
};
export default WorldMap;
//# sourceMappingURL=WorldMap.js.map